import { Controller } from '@hotwired/stimulus'
import { toggleVisibility } from 'utils/toggle_element_visibility'

export default class extends Controller {
  static targets = ["radio", "toggleableFormGroup"]

  toggleFormGroups() {
    const newState = this.radioTargets[0].checked

    this.toggleableFormGroupTargets.forEach((t) => {
      toggleVisibility(t, newState)
      t.disabled = !newState
      t.required = newState
    })
  }
}
